import type {
  PartitionCommandSelectionVFrame,
  SwitchSubPortfolioGroupCommandDataMFrame,
} from '@festina/unitlink-general-types/unitlink'

export const mapUpdatePartitionCommandSelectionsToVFrame = (
  updatePartitionCommandSelections: SwitchSubPortfolioGroupCommandDataMFrame['updatePartitionCommandSelections'],
) =>
  updatePartitionCommandSelections?.map(
    (partitionMFrame) =>
      ({
        _type: 'PartitionCommandSelectionVFrame',
        profileType: partitionMFrame?.profileType,
        fraction: partitionMFrame?.fraction,
        fundCommandSelections:
          partitionMFrame?.updateFundCommandSelections?.map((fundMFrame) => ({
            _type: 'FundCommandSelectionVFrame',
            fraction: fundMFrame?.fraction,
            isinKey: fundMFrame?.isinKey,
          })),
      }) satisfies PartitionCommandSelectionVFrame,
  )
